import { Container, Row, Col } from "react-bootstrap";
import { useState, useEffect } from "react";
import HeaderPersonal from "../../components/funcionarios/HeaderPersonal";
import ModulosDisplay from "../../components/funcionarios/ModulosDisplay";
import ModuloSeleccionado from "../../components/funcionarios/ModuloSeleccionado";
import {
  getMesones,
  actualizarEstadoMeson,
  obtenerFuncionario,
} from "../../services/apis_funcionarios";
import { actualizarFuncionario } from "../../services/apis_jefatura";

const styles = {
  container: {
    fontFamily: "var(--font-funcionarios)",
  },
};

function Inicio() {
  const [selectedModulo, setSelectedModulo] = useState(null);
  const [mesones, setMesones] = useState([]);
  const [error, setError] = useState(null);
  const [funcionarioId, setFuncionarioId] = useState(null);
  const [loadingFuncionario, setLoadingFuncionario] = useState(true);

  const handleCloseModulo = async () => {
    if (selectedModulo && funcionarioId) {
      try {
        // Actualizamos el estado del mesón a 'inactivo'
        await actualizarEstadoMeson(selectedModulo.id, "inactivo");
        // Desasignamos el mesón del funcionario (dejamos el campo meson vacío/null)
        await actualizarFuncionario(funcionarioId, { meson: null });

        // Refrescar la lista completa de mesones desde el backend
        const data = await getMesones();
        setMesones(data);
      } catch (err) {
        console.error("Error al actualizar el estado del mesón:", err);
      }
    }

    // Finalmente, deseleccionamos el módulo
    setSelectedModulo(null);
  };

  // Función para seleccionar módulo
  const handleSelectModulo = async (modulo) => {
    if (!funcionarioId) {
      console.error("No se pudo obtener el ID del funcionario");
      return;
    }

    try {
      await actualizarEstadoMeson(modulo.id, "activo");
      await actualizarFuncionario(funcionarioId, { meson: modulo.id });

      // Refrescar la lista completa de mesones desde el backend
      const data = await getMesones();
      setMesones(data);

      // Buscar el módulo actualizado en la lista refrescada
      const updatedModulo = data.find((m) => m.id === modulo.id);
      setSelectedModulo(updatedModulo || modulo);
    } catch (err) {
      console.error("Error al activar el mesón:", err);
    }
  };

  // Obtener información del funcionario desde /api/me/
  useEffect(() => {
    const API_URL = (import.meta?.env?.VITE_API_URL || "").replace(/\/$/, "");
    const url = `${API_URL}/api/me/`;

    fetch(url, { credentials: "include" })
      .then(async (res) => {
        if (!res.ok) throw new Error(`API /me/ respondió con ${res.status}`);
        return res.json();
      })
      .then((data) => {
        console.log("Datos recibidos de /api/me/:", data);

        const funcionarioId = data?.funcionario?.id;
        if (funcionarioId) {
          setFuncionarioId(funcionarioId);

          // Guardar en localStorage para uso futuro (ej: RequireAuth)
          localStorage.setItem(
            "funcionario",
            JSON.stringify({
              id: funcionarioId,
              nombre: data.funcionario.nombre,
              cargo: data.funcionario.cargo,
              username: data.user.username,
              email: data.user.email,
            })
          );

          console.log("Funcionario ID cargado:", funcionarioId);
        } else {
          console.warn("El usuario no tiene un funcionario asociado");
        }
      })
      .catch((err) => {
        console.error("Error obteniendo datos del usuario:", err);
      })
      .finally(() => {
        setLoadingFuncionario(false);
      });
  }, []);

  useEffect(() => {
    async function fetchMesones() {
      if (!funcionarioId) {
        // Esperar a que se cargue el funcionarioId
        return;
      }

      try {
        const data = await getMesones();
        setMesones(data);

        // Después de cargar los mesones, verificar si el funcionario tiene uno asignado
        try {
          const funcionarioData = await obtenerFuncionario(funcionarioId);

          if (funcionarioData.meson) {
            // Buscar el mesón asignado en la lista
            const mesonAsignado = data.find(
              (m) => m.id === funcionarioData.meson
            );

            if (mesonAsignado) {
              setSelectedModulo(mesonAsignado);
              console.log(
                "Módulo asignado recuperado desde API:",
                mesonAsignado
              );
            }
          }
        } catch (err) {
          console.error("Error al obtener datos del funcionario:", err);
          // No bloqueamos si falla, solo no mostramos módulo seleccionado
        }
      } catch (err) {
        console.error("Error cargando mesones:", err);
        setError("No se pudieron cargar los mesones.");
      }
    }

    fetchMesones();
  }, [funcionarioId]); // Ahora depende de funcionarioId

  if (loadingFuncionario) {
    return (
      <Container fluid>
        <Row
          className="justify-content-center align-items-center"
          style={{ minHeight: "60vh" }}
        >
          <Col xs="auto" className="text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Cargando...</span>
            </div>
            <p className="mt-3 text-muted">
              Cargando información del funcionario...
            </p>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <Container fluid className="p-0 m-0 w-100">
      <Row className="g-3">
        <Col lg={selectedModulo ? 6 : 12} className="h-md-100">
          <HeaderPersonal />
        </Col>

        {selectedModulo && (
          <Col lg={6} className="h-md-100">
            <ModuloSeleccionado
              modulo={selectedModulo}
              onClose={handleCloseModulo}
            />
          </Col>
        )}
        <Col xs={12}>
          {error ? (
            <p>{error}</p>
          ) : (
            <ModulosDisplay
              modulos={mesones}
              onSelectModulo={handleSelectModulo}
              selectedModulo={selectedModulo}
            />
          )}
        </Col>
      </Row>
    </Container>
  );
}

export default Inicio;
